// src/components/Store/CartDrawer.jsx
// Carrito deslizable desde la derecha (lista, entrega y pago en CartPanel).
import React from 'react';
import { Dialog, DialogBackdrop, DialogPanel, DialogTitle } from '@headlessui/react';
import { XMarkIcon } from '@heroicons/react/24/outline';
import { useTranslation } from 'react-i18next';
import CartPanel from './CartPanel';

const CartDrawer = ({ open, onClose, cartItems, onChangeQty, onRemove }) => {
  const { t } = useTranslation('common');
  return (
    <Dialog open={open} onClose={onClose} className="relative z-50">
      <DialogBackdrop
        transition
        className="fixed inset-0 bg-[#1f0a0a]/50 transition-opacity duration-300 ease-out data-[closed]:opacity-0"
      />
      <div className="fixed inset-0 flex justify-end">
        <DialogPanel
          transition
          className="flex h-full w-full max-w-md flex-col bg-[#EFE6DD] shadow-2xl transition-transform duration-300 ease-[cubic-bezier(0.32,0.72,0,1)] data-[closed]:translate-x-full"
        >
          <div className="flex items-center justify-between bg-[#9A0002] px-5 pb-4 pt-[max(1rem,env(safe-area-inset-top))] text-[#EFE6DD]">
            <DialogTitle className="text-lg font-semibold">{t('store.cartTitle')}</DialogTitle>
            <button
              type="button"
              onClick={onClose}
              className="flex h-9 w-9 items-center justify-center rounded-full hover:bg-[#7A0001] transition"
            >
              <span className="sr-only">{t('navbar.closeMenu')}</span>
              <XMarkIcon className="h-6 w-6" aria-hidden="true" />
            </button>
          </div>
          <div className="flex-1 overflow-y-auto overscroll-contain p-4 pb-[max(1rem,env(safe-area-inset-bottom))]">
            <CartPanel cartItems={cartItems} onChangeQty={onChangeQty} onRemove={onRemove} />
          </div>
        </DialogPanel>
      </div>
    </Dialog>
  );
};

export default CartDrawer;
